var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComponentsActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.029 7.971H7.97v7.058h7.058V7.97zm-2.353 4.705h-2.352v-2.352h2.352v2.352zm9.41-2.352V7.97h-2.353V5.62a2.36 2.36 0 00-2.352-2.352h-2.352V.914h-2.353v2.353h-2.352V.914H7.97v2.353H5.62a2.36 2.36 0 00-2.352 2.352v2.352H.914v2.353h2.353v2.352H.914v2.353h2.353v2.352a2.36 2.36 0 002.352 2.352h2.352v2.353h2.353v-2.353h2.352v2.353h2.353v-2.353h2.352a2.36 2.36 0 002.352-2.352v-2.352h2.353v-2.353h-2.353v-2.352h2.353zM17.38 17.38H5.619V5.619h11.762v11.762z",
    fill: "#2FC8FA"
  })));
}
export default SvgComponentsActive;